/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskWorkflowItemConfigurationTargeting } from './TaskWorkflowItemConfigurationTargeting';
import {
    TaskWorkflowItemConfigurationTargetingFromJSON,
    TaskWorkflowItemConfigurationTargetingFromJSONTyped,
    TaskWorkflowItemConfigurationTargetingToJSON,
    TaskWorkflowItemConfigurationTargetingToJSONTyped,
} from './TaskWorkflowItemConfigurationTargeting';

/**
 * Send task_workflow_item_id for a master item, optionally with display_name_override to rename it for the organization. Send only display_name_override for a custom organization item.
 * @export
 * @interface CreateTaskWorkflowItemConfigurationRequest
 */
export interface CreateTaskWorkflowItemConfigurationRequest {
    /**
     * 
     */
    task_workflow_item_id?: string;
    /**
     * 
     */
    display_name_override?: string;
    /**
     * 
     */
    targeting: TaskWorkflowItemConfigurationTargeting;
}

/**
 * Check if a given object implements the CreateTaskWorkflowItemConfigurationRequest interface.
 */
export function instanceOfCreateTaskWorkflowItemConfigurationRequest(value: object): value is CreateTaskWorkflowItemConfigurationRequest {
    if (!('targeting' in value) || value['targeting'] === undefined) return false;
    return true;
}

export function CreateTaskWorkflowItemConfigurationRequestFromJSON(json: any): CreateTaskWorkflowItemConfigurationRequest {
    return CreateTaskWorkflowItemConfigurationRequestFromJSONTyped(json, false);
}

export function CreateTaskWorkflowItemConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateTaskWorkflowItemConfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'task_workflow_item_id': json['task_workflow_item_id'] == null ? undefined : json['task_workflow_item_id'],
        'display_name_override': json['display_name_override'] == null ? undefined : json['display_name_override'],
        'targeting': TaskWorkflowItemConfigurationTargetingFromJSON(json['targeting']),
    };
}

export function CreateTaskWorkflowItemConfigurationRequestToJSON(json: any): CreateTaskWorkflowItemConfigurationRequest {
    return CreateTaskWorkflowItemConfigurationRequestToJSONTyped(json, false);
}

export function CreateTaskWorkflowItemConfigurationRequestToJSONTyped(value?: CreateTaskWorkflowItemConfigurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'task_workflow_item_id': value['task_workflow_item_id'],
        'display_name_override': value['display_name_override'],
        'targeting': TaskWorkflowItemConfigurationTargetingToJSON(value['targeting']),
    };
}

